import { Pipe, PipeTransform } from '@angular/core';
import { AuthoringPropertyTab } from '@adaptiva/metadata/common';

@Pipe({
	name: 'hasTab'
})
export class HasTabPipe implements PipeTransform {

	transform(_tab: AuthoringPropertyTab, _tabNames: AuthoringPropertyTab[]): boolean {
		return _tabNames.includes(_tab);
	}

}
